export const getFileExtensionFromUrl = (url: string) => {
    return url.split('?')[0].split('.').pop() ?? ""; // Extract the extension from the URL before the query params
};